<template>
  <div>
    <ValidationObserver
      autocomplete="off"
      tag="form"
      v-slot="{ handleSubmit }"
      @submit.prevent
    >
      <h3 class="form-legend font-size-h3 bb-1 mb-5">{{ $content.sign_in }}</h3>

      <div class="mb-3">
        <label for="signInEmail" class="label">{{ $content.your_email }}:</label>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <input
            autocomplete="off"
            id="signInEmail"
            type="text"
            class="form-control"
            v-model="userEmail">
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>

      <div class="mb-3">
        <label for="signInPassword" class="label">{{ $content.password }}:</label>
        <ValidationProvider rules="required" v-slot="{ errors }">
          <input
            autocomplete="off"
            id="signInPassword"
            type="password"
            class="form-control"
            v-model="userPassword">
          <p class="form-error">{{ errors[0] }}</p>
        </ValidationProvider>
      </div>

      <div>
        <p v-show="showError" class="c-pink mb-2">{{ $content.wrong_credentials }}</p>
        <button
          @click="handleSubmit(signIn)"
          type="submit"
          class="btn btn-primary btn-max">
          {{ $content.sign_in }}
        </button>
        <router-link
          @click.native="hideModal"
          class="c-gray t-small-caps mt-1 d-inline"
          to="/resetuj_haslo/">{{ $content.forgot_password}}</router-link>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
  import { ValidationProvider, ValidationObserver  } from 'vee-validate';
  import UserDataMixin from '../mixins/userdata';

  export default {
    name: 'SignInForm',
    mixins: [ UserDataMixin ],
    components: {
      ValidationProvider,
      ValidationObserver
    },
    data() {
      return {
        userEmail: '',
        userPassword: '',
        showError: false
      }
    },
    methods: {
      signIn() {
        this.showError = false;
        let formData = new FormData();
        formData.append('log', this.userEmail);
        formData.append('pwd', this.userPassword);

        this.$http.post('/wp-login.php', formData)
          .then(res => {
            if (res.status === 200) {
              if ( res.data.indexOf("sign-out") !== -1) {
                let userId = 0;
                this.$store.commit('setUserName', { name: this.userEmail });
                this.$store.dispatch('signIn');
                this.fetchUserData();
                  let matchUserId = res.data.match(/userId:( [0-9]+)/);
                  if (matchUserId != null) {
                      userId = parseInt(matchUserId[1], 10);
                  }

                  this.$gtm.trackEvent({
                      event: 'login',
                      category: 'prenumerata',
                      action: 'login',
                      label: 'user',
                      value: userId,
                      user_id: userId
                  });

                this.nextStep();
              } else {
                this.showError = true;
              }
            }
          })
          .catch(err => {
            this.showError = true;
          });

      },
      nextStep() {
        if (this.$store.state.selectedPlan.type === 'digital' && !this.$store.state.giftData.isGift) {
          this.$store.commit('setActiveStep', { activeStep: 'SummaryStep' });
        } else {
          this.$store.commit('setActiveStep', { activeStep: 'DeliveryStep' });
        }
      }
    }
  }
</script>
